export class ArchivoModel {

	constructor() { }

	public IdArchivo: number = 0;
	public IdSistema: number = 0;
	public Fecha: Date = null;
	public Titulo: string = "";
	public Descripcion: string = "";
	public Extencion: string = "";
	public Embebido: string = "";
	public Mostrar: boolean = false;
	public IdGrupo: number = 0;
	public IdAsociado: number = 0;
	public YouTubeID: string = "";
	public FVigencia: Date = null;

	public NombreDeArchivo: string = "";
	public Seleccionado: boolean = false;
	public Descargando: boolean = false;
}